export const ROOM_TYPE_LIST_ACTION = "ROOM_TYPE_ACTION";
export const ROOM_TYPE_LIST_SUCCESS = "ROOM_TYPE_LIST_SUCCESS";
export const ROOM_TYPE_LIST_FAIL = "ROOM_TYPE_LIST_FAIL";
export const ROOM_TYPE_DETAIL_ACTION = "ROOM_TYPE_DETAIL_ACTION";
export const ROOM_TYPE_DETAIL_SUCCESS = "ROOM_TYPE_DETAIL_SUCCESS";
export const ROOM_TYPE_DETAIL_FAIL = "ROOM_TYPE_DETAIL_FAIL";
export const ROOM_TYPE_FAIL = "ROOM_TYPE_FAIL";
export const ROOM_TYPE_SAVE_SUCCESS = "ROOM_TYPE_SAVE_SUCCESS";
export const ROOM_TYPE_SAVE_ACTION = "ROOM_TYPE_SAVE_ACTION";
export const ROOM_TYPE_SAVE_FAIL = "ROOM_TYPE_SAVE_FAIL";

export const ROOM_TYPE_CREATE_ACTION = "ROOM_TYPE_CREATE_ACTION";
export const ROOM_TYPE_CREATE_SUCCESS = "ROOM_TYPE_CREATE_SUCCESS";

export const ROOM_TYPE_CREATE_TRANSLATE_ACTION = "ROOM_TYPE_CREATE_TRANSLATE_ACTION";
export const ROOM_TYPE_CREATE_TRANSLATE_SUCCESS = "ROOM_TYPE_CREATE_TRANSLATE_SUCCESS";

export const ROOM_TYPE_UPDATE_TRANSLATE_ACTION = "ROOM_TYPE_UPDATE_TRANSLATE_ACTION";
export const ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS = "ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS";

export const ROOM_TYPE_DELETE_TRANSLATE_ACTION = "ROOM_TYPE_DELETE_TRANSLATE_ACTION";
export const ROOM_TYPE_DELETE_TRANSLATE_SUCCESS = "ROOM_TYPE_DELETE_TRANSLATE_SUCCESS";
export const ROOM_TYPE_ALL_HOTEL_ACTION = "ROOM_TYPE_HOTEL_ALL_ACTION";
export const ROOM_TYPE_ALL_HOTEL_SUCCESS = "ROOM_TYPE_ALL_HOTEL_SUCCESS";